import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SearchCatalogItemsSchema } from 'features/SearchCatalogItems';

const initialState: SearchCatalogItemsSchema = {
    isActive: false,
    globalCatItemSearchValue: '',
    localCatItemSearchValue: '',
    skipReset: false,
};

export const SearchCatalogItemsSlice = createSlice({
    name: 'SearchCatalogItems',
    initialState,
    reducers: {
        setActive: (state, action: PayloadAction<boolean>) => {
            state.isActive = action.payload;
        },
        setGlobalCatItemSearchValue: (state, action: PayloadAction<string>) => {
            state.globalCatItemSearchValue = action.payload;
        },
        setLocalCatItemSearchValue: (state, action: PayloadAction<string>) => {
            state.localCatItemSearchValue = action.payload;
        },
        setSkipReset: (state, action: PayloadAction<boolean>) => {
            state.skipReset = action.payload;
        },
        resetSearch: (state) => {
            if (state.skipReset) {
                state.skipReset = false;
                return;
            }
            return initialState;
        },
    },
});

export const { actions: searchCatalogItemsActions } = SearchCatalogItemsSlice;
export const { reducer: searchCatalogItemsReducer } = SearchCatalogItemsSlice;
